module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-00-9868f8fe8c0bffc5bbd6ec8540f67e0d.svg";